
import React from 'react';
import AuthLayout from '@/components/auth/AuthLayout';
import ResetPasswordForm from '@/components/auth/ResetPasswordForm';
import { useNavigate } from 'react-router-dom';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useUser } from '@/contexts/UserContext';

export default function ResetPassword() {
  const { isPasswordRecovery, isLoading: authLoading } = useUser();
  const navigate = useNavigate();

  // No useEffect needed - we rely on UserContext for password recovery state

  // Show loading spinner while auth state is being determined
  if (authLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // If not in password recovery mode, show error
  if (!isPasswordRecovery) {
    return (
      <AuthLayout 
        title="Invalid Reset Link" 
        description="This password reset link is invalid or has expired"
      >
        <Alert variant="destructive">
          <AlertDescription>
            This password reset link is invalid or has expired. Please request a new password reset.
          </AlertDescription>
        </Alert>
        <div className="mt-4 text-center">
          <button
            onClick={() => navigate('/auth/forgot-password')}
            className="text-sm text-primary hover:underline"
          >
            Request new reset link
          </button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout 
      title="Set New Password" 
      description="You've successfully verified your identity. Please enter a new password for your account."
    >
      <ResetPasswordForm />
    </AuthLayout>
  );
}
